import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export function validationsReducer(state = initialstate.validations, action) {
	switch (action.type) {
		case types.GET_VALIDATIONS:
			return action.response || state;
		default:
			return state;
	}
}
